// extracted by mini-css-extract-plugin
export default {"searchWrapper":"search-results_searchWrapper__XW2Vk","searchTerm":"search-results_searchTerm__vzkZI","results":"search-results_results__aoKSo"};